import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { componentAdvosysInitI18n, ComponentAdvosysProvider, ModuleAccessProvider, PreloadApiCapabilities } from "@advosys/component-advosys-react";
import { componentAppServerClientInitI18n, setAppServerSettings, setGetAuthenticationHeaderAsync, setTenantId } from "@advosys/component-app-server-client-js";
import { defaultTheme, Initialize, KeyboardShortcutManager, muiTheme, ThemeProvider } from "@advosys/component-react";
import { ensureValue, hasValue, initLocale, nameOf } from "@advosys/component-react-utils";
import "moment/locale/da";
import "numeral/locales/da-dk";
import { resources } from "src/i18n";
import { cacheInformation, loadLanguage } from "./core";
import { createApplicationStore } from "./create-application-store";
import { ApplicationRoutes } from "./routes";
import { getAuthenticationHeaderAsync, getBaseUrl } from "./backend/app-server";
import { BackendAccess } from "./domains/application";
import { CallbackHandler, LoginGate } from "./domains/authentication";
import { mockAppServer } from "./mock/utils/mock-utils";
initLocale();
setAppServerSettings(getBaseUrl());
setGetAuthenticationHeaderAsync(getAuthenticationHeaderAsync);
const mockAppServerKey = "mock-app-server";
const params = new URLSearchParams(window.location.search);
if (hasValue(params.get(mockAppServerKey))) {
    sessionStorage.setItem(mockAppServerKey, "true");
}
const enableMockAppServer = sessionStorage.getItem(mockAppServerKey) === "true";
if (enableMockAppServer) {
    mockAppServer();
}
const Content = () => {
    const { tenantId } = useParams();
    const [store, setStore] = useState();
    useEffect(() => {
        if (hasValue(tenantId)) {
            setTenantId(tenantId);
            setStore(createApplicationStore());
        }
    }, [tenantId]);
    if (!hasValue(store))
        return null;
    return (_jsx(ComponentAdvosysProvider, { store: store, children: _jsx(LoginGate, { children: _jsx(PreloadApiCapabilities, { cacheOptions: cacheInformation.apiCapabilities, children: _jsx(BackendAccess, { children: _jsx(ModuleAccessProvider, { cacheOptions: cacheInformation.moduleAccess, children: _jsx(ApplicationRoutes, {}) }) }) }) }) }));
};
const language = loadLanguage();
const root = createRoot(ensureValue(document.getElementById("root")));
root.render(_jsx(BrowserRouter, { children: _jsx(KeyboardShortcutManager, { children: _jsx(ThemeProvider, { fluentTheme: defaultTheme, muiTheme: muiTheme, children: _jsx(Initialize, { resources: resources, language: language, i18nInitFunctions: [componentAppServerClientInitI18n, componentAdvosysInitI18n], children: _jsxs(Routes, { children: [_jsx(Route, { path: `/:${nameOf("tenantId")}/*`, element: _jsx(Content, {}) }), _jsx(Route, { path: "/", element: _jsx(CallbackHandler, {}) })] }) }) }) }) }));
